import { render, staticRenderFns } from "./GridSQTV.vue?vue&type=template&id=bc99b986&scoped=true"
import script from "./GridSQTV.vue?vue&type=script&lang=ts&setup=true"
export * from "./GridSQTV.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GridSQTV.vue?vue&type=style&index=0&id=bc99b986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc99b986",
  null
  
)

export default component.exports